import React, { PureComponent } from "react";
import { Form, Button, Col, Row, message, Modal } from "antd";
import mes1 from "images/edu/mes1.png";
import message01 from "images/soldier/message1.png";
import { Link } from "react-router-dom";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import { getCurrentUser } from "utils/storage";
import { getcodeValue } from "../../utils/storage";
const FormItem = Form.Item;
require("./createAssistItem.scss");
export default class DeucationTrainingPolicyDetail extends PureComponent {
  state = {
    sourseId: "",
    courseInfo: {},
    modalVisible: false,
  };
  componentDidMount() {
    console.log(
      "看一下有哪些信息",
      this.props.location.pathname.split("/").slice(-1)
    );
    let sourseId = this.props.location.pathname.split("/").slice(-1);
    this.getDetail(sourseId[0]);
    this.setState({ sourseId: sourseId[0] });
  }
  //获取详情
  getDetail = (data) => {
    console.log("id信息", data);
    let params = {
      id: data,
    };
    Http.getApplication(Request.serveListDetail(), { ...params }, (obj) => {
      console.log(obj);
      if (obj.code == 200) {
        this.setState({
          courseInfo: obj.data,
          //    courseList:obj.data.records
        });
      }
    });
  };
  renderBaesInfo = (data) => {
    if (data && data.length) {
      return data.map((item, index) => {
        return (
          <Col span={24} key={index}>
            <FormItem label={item.name}>{item.value}</FormItem>
          </Col>
        );
      });
    }
  };
  getApply = () => {
    message.config({
      top: 50,
      duration: 1,
      maxCount: 1,
    });
    const { sourseId } = this.state;
    if (!getCurrentUser()) {
      message.error("还未登录，请先登录后申请！");
      this.props.history.push("/login");
      return;
    }
    if (getCurrentUser().user_type != "2") {
      message.warn("非退役军人不可申请!");
      return;
    }
    this.setState({
      modalVisible: true,
    });
  };
  handleOk = () => {
    const { sourseId } = this.state;
    Http.post(Request.applyFor(), { servicesId: sourseId }, (obj) => {
      if (obj.code == 200) {
        message.success("申请成功", 2);
      } else {
        message.info(obj.msg || "申请失败", 2);
      }
    });
    this.setState({
      modalVisible: false,
    });
  };
  handleCancel = () => {
    this.setState({
      modalVisible: false,
    });
  };

  render() {
    const { courseInfo, modalVisible } = this.state;
    let photoUrl = {};
    if (courseInfo.sybPhotoManage !== undefined) {
      photoUrl =
        courseInfo.sybPhotoManage[0] == undefined
          ? ""
          : courseInfo.sybPhotoManage[0].photoUrl;
    }
    console.log("photoUrlphotoUrl", photoUrl);

    const courseList = [
      {
        name: "所属行业",
        value: courseInfo
          ? getcodeValue("industry_code", courseInfo.servicesIndustry)
          : "",
      },
      {
        name: "发布单位",
        value: courseInfo ? courseInfo.releaseUnit : "",
      },
      {
        name: "发布时间",
        value: courseInfo ? courseInfo.releaseTime : "",
      },
      {
        name: "发布人",
        value: courseInfo ? courseInfo.releaseBy : "",
      },
      {
        name: "项目联系人",
        value: courseInfo ? courseInfo.servicesPerson : "",
      },
      {
        name: "联系电话",
        value: courseInfo ? courseInfo.servicesPhone : "",
      },
    ];

    return (
      <div className="createAssistItem">
        <div className="conBox">
          <div className="Base_Detils_Box">
            <span>
              当前位置：创业帮扶 /{" "}
              <span
                style={{ cursor: "pointer" }}
                onClick={() =>
                  this.props.history.push("/entrance/entrepreneurship")
                }
              >
                创业服务申请
              </span>
              /{" "}
            </span>
            <span style={{ color: "#3356C5" }}> 服务申请详情</span>
          </div>
          <div className="topbox">
            <div className="left">
              <img src={photoUrl} alt="" />
            </div>
            <div className="right">
              <div className="courseInfoBox">
                <span className="courseName">{courseInfo.servicesName}</span>
                <span>
                  {/* <span className="courseInfoList_top">{courseInfo.servicesIndustry}</span> */}
                  <div>
                    {/* <Button type='primary'  className='leftBtn' onClick={this.getApply}>申请创业服务</Button> */}
                    <Button
                      style={{ marginLeft: "20px" }}
                      onClick={this.props.history.goBack}
                    >
                      返回
                    </Button>
                  </div>
                </span>
              </div>

              <div className="courseInfoList">
                <Form
                // labelCol={{ span: 8 }}
                // wrapperCol={{ span: 16 }}
                >
                  <Row gutter={[24, 2]}>
                    {courseInfo ? this.renderBaesInfo(courseList) : ""}
                  </Row>
                </Form>
              </div>
            </div>
          </div>
          <div className="btoBox">
            <div className="eduDetailInfo">
              <h2>项目实施地址</h2>
              {/* <p>{courseInfo.trainingIntroduce}</p> */}
              <p>{courseInfo.servicesAddress}</p>
            </div>
            <div className="eduDetailInfo">
              <h2>项目介绍</h2>
              {/* <p>{courseInfo.trainingTime}</p> */}
              <p>{courseInfo.servicesDetail}</p>
            </div>
          </div>
        </div>
        <Modal
          title="创业服务申请"
          visible={modalVisible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          {/* {renderBasicInfo()} */}
          <span style={{ fontSize: 20 }}>确定申请创业服务吗</span>
        </Modal>
      </div>
    );
  }
}
